const MoveAction = ({ width, height }: { width: number; height: number }) => {
    return (
        <div
            className="l-cropStage-moveAction"
            data-type="move"
            style={{
                width: width,
                height: height,
            }}
        />
    );
};

export default MoveAction;
